<script setup lang="ts">
const props = defineProps<{
  controller: ReturnType<typeof useModal>
}>()

const isOpen = computed(() => props.controller.isOpen.value)
</script>

<template>
  <Teleport to="body">
    <div v-if="isOpen" ref="target" class="modal">
      <button class="close" type="button" @click="controller.close">
        <Icon name="large-close" />
      </button>

      <div class="content">
        <slot />
      </div>
    </div>
  </Teleport>
</template>

<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  padding: 40px 20px;

  height: 100%;
  background-color: var(--c-white);
  overflow-y: scroll;
  z-index: 102;

  @include breakpoint(ts) {
    padding: 120px 95px;
  }
}

.close {
  position: absolute;
  top: 10px;
  right: 10px;

  @include breakpoint(ts) {
    top: 40px;
    right: 40px;
  }

  svg {
    width: 25px;
    height: 25px;

    @include breakpoint(ts) {
      width: 30px;
      height: 30px;
    }
  }
}

.content {
  max-width: 840px;
  width: 100%;
  margin-inline: auto;
}
</style>
